import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XpoLtlBaseCacheService } from '@xpo-ltl/ngx-ltl';
import { ClaimsApiService, ListExaminerActiveSubrogatedClaimsQuery, ListExaminerActiveSubrogatedClaimsResp } from '@xpo-ltl-2.0/sdk-claims';
import * as _ from 'lodash';
import { ApiRequest } from '@xpo-ltl/data-api';
import { AssignedActiveSubrogatedCacheParams } from '../../interfaces/assigned-active-subrogated-cache-params.interface';
import { ListInfo } from '@xpo-ltl/sdk-common';

@Injectable()
export class ListActiveSubrogatedClaimsCacheService extends XpoLtlBaseCacheService<AssignedActiveSubrogatedCacheParams, ListExaminerActiveSubrogatedClaimsResp> {
  constructor(private claimsApiService: ClaimsApiService) {
    super();
  }

  protected getKeyFromParams(params: AssignedActiveSubrogatedCacheParams): string {
    return `${params.index}`;
  }

  protected requestData(params: AssignedActiveSubrogatedCacheParams): Observable<ListExaminerActiveSubrogatedClaimsResp> {
    const request = new ListExaminerActiveSubrogatedClaimsQuery();
    _.assign(request, _.pick(params, _.keys(request)));
    request.examinerEmployeeId = params.employeeId;
    request.listInfo = new ListInfo();
    request.listInfo.startAt = params.startAt;
    request.listInfo.numberOfRows = params.numberOfRows;
    request.listInfo.sortFields = [{sortByFieldName: params.sortByFieldName.toString(), sortOrder: params.sortOrder.toString()}];

    return this.claimsApiService.listExaminerActiveSubrogatedClaims(request, { ...ApiRequest.defaultDataOptions, toastOnError: false });
  }
}
